import React from 'react';
import { AppBar, CardMedia, Container, Link, Grid, Typography } from '@mui/material';
import Social from 'components/header/social';
import Logo from 'components/header/widgets/logo';
import { useDispatch, useSelector } from 'react-redux';
import { setGuest } from 'api/session';
import Flag from './widgets/flag';
import DashboardLogin from './widgets/login';
import PaySubscription from './widgets/pay';
import CreateAccount from './widgets/create';

const Header = (props) => {
    const guest = useSelector(state => state.session.guest);
    const dispatch = useDispatch();
    const onSignOut = () => {
        var guestUpdate = {
            isAuthenticated: false,
            email: "",
        }
        localStorage.setItem('tirefaxGuestDetails', JSON.stringify(guestUpdate));
        dispatch(setGuest(guestUpdate));
    }

    return (
        <AppBar sx={{ backgroundColor: "#fff", color: "#000", }} elevation={5} >
            <Container maxWidth={'xl'} disableGutters>
                <Grid container item
                    direction={"column"}
                    disableGutters
                    sx={{
                        display: {
                            xs: "flex",
                            sm: "none"
                        }
                    }}
                >
                    <Grid container item
                        xs={12}
                        direction={"row"}
                        justifyContent={'space-between'}
                    >
                        <Logo />
                        <Flag />
                    </Grid>
                    <Grid container item
                        xs={12}
                        direction={"row"}
                        justifyContent={'space-between'}
                        sx={{
                            paddingBottom: "20px",
                            paddingX: "10px"
                        }}
                    >

                        <DashboardLogin />
                        <PaySubscription />
                    </Grid>
                </Grid>
                <Grid container item
                    direction={"row"}
                    justifyContent={'space-between'}
                    alignItems={"center"}
                    disableGutters
                    sx={{
                        display: {
                            xs: "none",
                            sm: "flex",
                            md: "none"
                        }
                    }}
                >
                    <Grid container item
                        xs={3}
                        direction={"row"}
                        justifyContent={'stant'}
                    >
                        <Logo />
                    </Grid>
                    <Grid container item
                        xs={9}
                        direction={"row"}
                        justifyContent={'flex-end'}

                    >
                        <DashboardLogin />
                        <PaySubscription />
                        <Flag />
                    </Grid>
                </Grid>
                <Grid container item
                    direction={"row"}
                    justifyContent={'space-between'}
                    alignItems={"center"}
                    disableGutters
                    sx={{
                        display: {
                            xs: "none",
                            md: "flex",
                        }
                    }}
                >
                    <Grid container item
                        xs={3}
                        direction={"row"}
                        justifyContent={'stant'}
                    >
                        <Logo />
                    </Grid>
                    <Grid container item
                        xs={9}
                        direction={"row"}
                        justifyContent={'flex-end'}

                    >
                        <DashboardLogin />
                        <PaySubscription />
                        <CreateAccount />
                        <Flag />
                    </Grid>
                </Grid>
            </Container>
        </AppBar >
    )
}

export default Header;